import { render } from "./LeagueStar.vue?vue&type=template&id=37d3a5d6&scoped=true"
import script from "./LeagueStar.vue?vue&type=script&lang=js"
export * from "./LeagueStar.vue?vue&type=script&lang=js"

import "./LeagueStar.vue?vue&type=style&index=0&id=37d3a5d6&lang=less&scoped=true"

import exportComponent from "/home/jenkins_home/workspace/c1-02_dwart2.0-apkpc-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37d3a5d6"]])

export default __exports__